export default __webpack_public_path__ + "static/media/1944.cfd3eb79.png";